"use client";

import cn from "classnames";
import { useTranslations } from "next-intl";

import { Level, UserOnboarding } from "@/types";
import { levels } from "@/utils/constants";

interface ProficiencySelectorProps {
    selected?: Level | null;
    onSelect: (userOnboarding: UserOnboarding) => void;
}

const ProficiencySelector = ({
    onSelect,
    selected
}: ProficiencySelectorProps) => {
    const t = useTranslations("Levels");
    const tWelcome = useTranslations("Welcome");

    return (
        <>
            <h1 className="text-4xl font-bold mb-12 text-center">
                {tWelcome("proficiency_headline")}
            </h1>
            <div className="grid gap-4 justify-center">
                {levels.map((level) => (
                    <button
                        key={level}
                        className={cn(
                            "flex flex-col border min-w-[16rem] border-gray-300 bg-white hover:bg-gray-100 py-2 px-4 rounded-lg text-left",
                            {
                                "ring-2 ring-offset-2 ring-blue-600":
                                    selected === level
                            }
                        )}
                        onClick={() => onSelect({ proficiency: level })}
                    >
                        <span className="text-lg font-medium">{t(level)}</span>
                        <span className="text-sm text-zinc-500">
                            {t(`${level}_description`)}
                        </span>
                    </button>
                ))}
            </div>
        </>
    );
};

export default ProficiencySelector;
